import colors from "@/constants/colors";
const mela = (name: string, fallback: string) =>
  `var(--mela-${name}, ${fallback})`;

export const safetyColors = {
  // Brand / accents
  brandNavy: colors.darkGrey,
  info: colors.blue,
  infoBg: mela("color-primary-soft-bg", "#e6f6fe"),
  indigo: colors.darkBlue,
  indigoBg: mela("color-primary-soft-bg", "#e6f6fe"),
  purple: mela("color-ai-soft-text", "#6d28d9"),
  purpleDark: mela("color-ai-soft-text", "#6d28d9"),
  purpleBg: mela("color-ai-soft-bg", "#f5f3ff"),
  // Group colours that no status or AI mark uses: the app's mint, darkened
  // enough to read as text, and the brand's secondary graphite.
  teal: `color-mix(in srgb, ${colors.green} 55%, #000)`,
  graphite: colors.darkGrey,
  rose: "color-mix(in srgb, #fd79a8 60%, #000)",

  // Status semantics
  ok: mela("color-success-soft-text", "#166534"),
  okBorder: mela("color-success-soft-border", "#86efac"),
  okBg: mela("color-success-soft-bg", "#dcfce7"),
  warning: mela("color-warning-soft-text", "#c2410c"),
  warningBorder: mela("color-warning-soft-border", "#fdba74"),
  warningBg: mela("color-warning-soft-bg", "#fff7ed"),
  danger: mela("color-danger-soft-text", "#dc2626"),
  dangerBorder: mela("color-danger-soft-border", "#fecaca"),
  dangerBg: mela("color-danger-soft-bg", "#fef2f2"),

  // Neutral text
  textStrongest: colors.darkGrey,
  textStrong: colors.black,
  textDark: colors.black,
  textMid: mela("text-secondary", "#4b5563"),
  textSubtle: mela("text-muted", "#64748b"),
  muted: colors.ashGrey,
  mutedDark: mela("text-muted", "#64748b"),
  mutedLight: colors.lightGrey,

  // Surfaces / borders
  white: colors.white,
  border: colors.lightLightGrey,
  borderLight: colors.gray,
  surface: colors.gray,
  surfaceAlt: colors.screen.secondary,
  surfaceBlue: colors.lightBlue,
} as const;

export const safetyType = {
  micro: "0.75rem",
  caption: "0.8125rem",
  body: "0.875rem",
  bodyStrong: "0.9375rem",
  subtitle: "1rem",
  title: "1.125rem",
  cardTitle: "1.2rem",
  heading: "1.25rem",
  display: "2rem",
} as const;
